import { render, staticRenderFns } from "./MessagesCard.vue?vue&type=template&id=6c370b1c&"
import script from "./MessagesCard.vue?vue&type=script&lang=js&"
export * from "./MessagesCard.vue?vue&type=script&lang=js&"
import style0 from "./MessagesCard.vue?vue&type=style&index=0&id=6c370b1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports